export default "__VITE_ASSET__ab022654__"